import { render, staticRenderFns } from "./mi_juguete.vue?vue&type=template&id=78b9c468&scoped=true"
import script from "./mi_juguete.vue?vue&type=script&lang=js"
export * from "./mi_juguete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b9c468",
  null
  
)

export default component.exports